// BjxyPage.jsx — /bjxy 页面 8 section 完整渲染
// v0.1.0i 修: 之前 class 命名跟 less/forum.less 不一致, 全部 grid / card / hover styles 没生效
//   改成跟 less 对齐的命名: .bjxy-section / .bjxy-feature / .bjxy-stat / .bjxy-coach
//   .bjxy-curri-tabs / .bjxy-curri-tab / .bjxy-level-card / .bjxy-section .bjxy-sub
// 8 section settings 走 app.forum.attribute('bjxy_*') (SOP 56)
// 17 级 + 6 特色 走 app.data.bjxyCurriculum / bjxyFeatures (vendor custom payload)
// v0.1.6a: 评价多图 (大众点评风格) + 活动展示 swiper 轮播 + 复用 ziven-core fancybox
//   复用 ziven-core 的 app.fancyboxOpen 跟 window.Fancybox (ziven-core/forum/index.js 静态加载)
//   swiper 走本地 npm install (跟 sortablejs v0.1.4 一样路线)
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
// v0.1.6a: 引入 swiper ES module
// v0.1.6c 改: swiper 11 navigation/pagination 是独立 modules, 必须显式 import + 传 modules: [...]
//   之前 v0.1.6a+b 只 import Swiper default, swiper 11 默认不 attach navigation/pagination
//   (modules 数组只有 ['0', '1'] 表示 core + virtual), 按钮 click 没绑 event
//   辉哥 12:55 反馈 "swiper 左右切换箭头点击没效果", 确认 navigation 初始化失败
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
// v0.2.0: 预约体验 modal (辉哥 2026-08-09 8:14 反馈)
//   新按钮触发 app.modal.show(BookingModal), 6 字段表单 + 限流 + 邮件通知 admin
import BookingModal from './BookingModal';
// v0.5.10.a 撤 (辉哥 2026-08-30 23:44 反馈): 调试用对照 modal TestModal + 入口
//   iPhone 真机亲测后确认: Flarum 2.0 原生 modal 自身 bug (iOS 14+ body-scroll-lock 库失效),
//     不管是 BookingModal 还是最简 TestModal 都跳顶, 跟 BookingModal 自己代码无关
//   TestModal.jsx 文件一并删, 留 import 会变 dead import
// import TestModal from './TestModal';

const DEFAULT_BRAND = '北极雪屿';
const DEFAULT_SLOGAN = '室内滑雪 · 全国连锁';
export default class BjxyPage extends Component {
  // v0.1.22: /bjxy 路径 title 改为品牌名 + 品牌副标 (辉哥 18:38 新需求)
  //   override vendor Page.setTitle() 默认行为 (vendor Page L89-91 / IndexPage L89-92):
  //     app.setTitle(extractText(app.translator.trans('core.forum.index.meta_title_text'))) + setTitleCount(0)
  //   不调 vendor 默认 setTitle, 完全自定义. 走 bjxy_brand_name / bjxy_brand_slogan setting,
  //   后台 '品牌信息' tab 配置 (BjxySettings.jsx L511-519), 留空时 fallback 到 '北极雪屿' + '室内滑雪 · 全国连锁'
  setTitle() {
    const brandName = app.forum.attribute('bjxy_brand_name') || DEFAULT_BRAND;
    const brandSlogan = app.forum.attribute('bjxy_brand_slogan') || DEFAULT_SLOGAN;
    app.setTitle(brandName + ' · ' + brandSlogan);
    app.setTitleCount(0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    // v0.2.0i.k 新 (辉哥 2026-08-12 16:05 反馈): oninit push history 让返回按钮能跳回 bjxy
    //   根因: vendor Navigation 组件 L33 canGoBack() = stack.length > 1, 没 push 就不显示
    //   修法: 跟 vendor IndexPage L57 / PostsPage L33 / UserPage L85 模式一致
    //   History.push() L41-46 检查 top 同名会覆盖, 不会 stack 重复
    //   返回按钮跳回 /bjxy (直接路径, 不依赖 default_route 配置)
    //   适用: 任何 bjxy 自定义 page 都要 push history entry, 否则跳其他页面没返回按钮
    app.history.push('bjxy', 'bjxy 官网', '/bjxy');
    // v0.2.0i.k.b 新 (辉哥 2026-08-12 17:35 反馈): sessionStorage 持久化 bjxy 路径 + active flag
    //   背景: vendor History 是 session-only 内存, 刷新后 mithril 重建 stack, bjxy entry 丢
    //   辉哥实测: 刷新 /u/wfl → stack 变成 [user.posts], 没 bjxy entry, 返回按钮跳 / (首页)
    //   修法: 把 bjxy path + active flag 写到 sessionStorage, forum/index.js 劫持 m.route.set 在跳 /u/... 时 push bjxy entry
    //   两个 key 用途不同:
    //     - 'ziven-bjxy-prev-path' = '/bjxy': 持久化 prev path (备用, 实际劫持用 active flag)
    //     - 'ziven-bjxy-active' = '1': 标志用户在当前 SPA session 内访问过 bjxy (劫持判断条件, 区分 /d/1 → /u/ 副作用)
    //   配合: forum/index.js 注入 m.route.set 劫持器, 在 /u/ 跳转前 push bjxy entry (仅当 active='1')
    //   关键: onremove 清 active (避免 /d/1 → /u/ 副作用, 详见 forum/index.js 注释)
    try {
      sessionStorage.setItem('ziven-bjxy-prev-path', '/bjxy');
      sessionStorage.setItem('ziven-bjxy-active', '1');
    } catch (e) {
      // sessionStorage 可能被禁用 (隐私模式), 静默失败
    }
    this.coaches = [];
    this.loadingCoaches = true;
    // v0.1.0s 改: activeBoard 从 string 'single' 改成 index (0/1/2...)
    //   因为现在 boards 数组任意多类型, 不再固定 2 个
    this.activeBoard = 0;
    // v0.2.0i.i 新 (辉哥 2026-08-12 07:42 反馈): bjxy 官网桌面端 sidebar 收起 + display:none
    //   App-sidebar-aura 来源: ziven-theme-aura vendor 扩展 (vendor/ziiven/theme-aura/)
    //   辉哥要: bjxy 官网桌面端 sidebar 不可见 (不是 vendor 折叠 transform 动画)
    //   修法: page-level 控制 body class
    //     - oninit add class 'App-sidebar-aura-collapsed' (跟 vendor 折叠状态 class 同名, 跟 vendor 折叠机制一致)
    //     - onremove remove class (切回 /d /u /all 等其他路径, sidebar 恢复 vendor 默认)
    //   CSS 配合 less/forum.less 桌面端段: body.App-sidebar-aura-collapsed .App-sidebar-aura { display: none !important }
    //   风险: 跟 vendor localStorage 'ziven-aura-sidebar-collapsed' 独立, 不会冲突 (vendor modifySidebar.js L61-64 只看 localStorage, 不查 body class)
    //   mobile 不动: CSS 套 @media (min-width: 992px), mobile 走 vendor 移动端 drawer
    // v0.2.0i.n 新 (辉哥 2026-08-13 12:00 反馈): page-level body class 控制 mobile tab 隐藏 + #app padding-top
    //   走 SOP 234 page-level 套路, 跟 v0.2.0i.i App-sidebar-aura-collapsed 一致
    //   之前 v0.1.17~v0.2.0i.l 都用 oncreate 注入 <style id="bjxy-hide-mobile-tab">, 漏 onremove 清理
    //     跨路由污染下一个页面 (移动端 /u/wfl 多 17.8px padding)
    //   修法: 改成 less 段 + body class, oninit add class, onremove remove class
    //   v0.2.0r.a 改 (辉哥 2026-08-29 拍板): 删 nav.MobileTab 隐藏那段
    //   v0.2.0i.aa.a 改 (辉哥 2026-08-31 16:21 反馈): bjxy 顶部恢复 vendor Flarum 原生 top bar, 删 #header hide + #app padding-top 63.8 2 段死代码
    //     (v0.2.0i.aa 撤回调后 bjxy 自建 bjxy-nav 不在了, 那 2 段作用是"藏 vendor #header + 给 bjxy-nav 留位置", 变死代码, 删掉)
    //   v0.2.0i.aa.b 改 (辉哥 2026-08-31 16:46 拍板 A 方案): 删整个 bjxy 自建导航 (logo + 7 锚点 + 预约体验按钮), bjxy 顶部完全走 vendor Flarum 原生 top bar
    //     配套 less 段 (v0.2.0i.aa.b 当前 5 段): body.bjxy-page-active { footer.App-footer hide; div.coreFooter hide; .App.affix pb 0; .App-content pb 0; .MobileTab z-index 1200; }
    //   老 fallback: onremove 兜底 getElementById("bjxy-hide-mobile-tab")?.remove() 兼容老 user 老 cache
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.add('App-sidebar-aura-collapsed');
      // v0.2.0i.n: 加 page-level class
      document.body.classList.add('bjxy-page-active');
    }
  }

  // v0.1.6: 评分转 ★☆ 字符串 (1-5 整数)
  renderStars(rating) {
    const r = Math.max(1, Math.min(5, parseInt(rating) || 5));
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  // v0.1.6a: fancybox 多图 gallery 工具
  //   复用 ziven-core 的 window.Fancybox (ziven-core/forum/index.js 静态加载)
  //   直接调 Fancybox.show 不依赖 app.fancyboxOpen (那个只支持单图)
  //   等 window.Fancybox 加载完成 (ziven-core 是静默加载, 可能 page render 时还没好)
  openFancyboxGallery(urls, idx) {
    if (idx === void 0) {
      idx = 0;
    }
    if (!urls || urls.length === 0) return;
    const doOpen = () => {
      if (window.Fancybox && window.Fancybox.show) {
        window.Fancybox.show(urls.map(u => ({
          src: u,
          type: 'image'
        })), {
          startIndex: idx,
          dragToClose: false
        });
      } else {
        console.warn('Fancybox not loaded yet, retry...');
      }
    };
    if (window.Fancybox && window.Fancybox.show) {
      doOpen();
    } else {
      // 触发 ziven-core 加载, 然后轮询等
      if (app && app.fancyboxOpen) app.fancyboxOpen(urls[0]);
      let attempts = 0;
      const check = setInterval(() => {
        attempts++;
        if (window.Fancybox && window.Fancybox.show) {
          clearInterval(check);
          doOpen();
        } else if (attempts > 50) {
          clearInterval(check);
          console.error('Fancybox load timeout');
        }
      }, 100);
    }
  }

  // v0.1.6a: swiper 初始化 (评价/活动 轮播)
  //   vnode.dom 是 swiper container
  //   onremove 时销毁避免内存泄漏
  // v0.1.6c 改: 加 modules: [Navigation, Pagination]
  // v0.1.6g 改: 加 Autoplay module, delay 从 bjxy_events_autoplay_ms setting 读
  //   delay 默认 3000ms, disableOnInteraction=false 用户操作后继续自动轮播
  initSwiper(vnode) {
    if (!vnode || !vnode.dom) return;
    if (this.swiper) this.swiper.destroy(true, true);
    const autoplayMs = parseInt(app.forum.attribute('bjxy_events_autoplay_ms'), 10) || 3000;
    this.swiper = new Swiper(vnode.dom, {
      // v0.1.6c: 必须传 modules, 不传 swiper 11 navigation/pagination 不会 attach
      // v0.1.6g: 加 Autoplay module (SOP 90)
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      // v0.2.0h 改: 显式分 3 段 viewport (辉哥 14:15 反馈, 跟 v0.1.38 768+ 跳 desktop 2 累计)
      //   mobile (< 768px) 1, tablet (768-1024) 2, desktop (>= 1024) 2
      //   swiper 11 breakpoints 触发 slidesPerView 切换, 跟 v0.1.30 swiper peek breakpoints 模式一致
      //   events 段 tablet + desktop 都 2 卡 (跟 v0.1.38 行为不变, 显式分段)
      slidesPerView: 1,
      spaceBetween: 16,
      // v0.2.0i.o 改: 移动端 events swiper 修法 (辉哥 16:00 反馈 /bjxy 最新活动图片 fancybox 不弹)
      //   根因: swiper 11 移动端默认配置, 第一个 slide 在 viewport 左侧外 (Puppeteer x=-179)
      //   + swiper 11 默认 preventClicks=true 拦截 photo click
      //   修法: centeredSlides + initialSlide + preventClicks: false + noSwipingClass 4 件套
      //   - centeredSlides: 移动端首张居中, 解决"首张在 viewport 外"问题
      //   - initialSlide: 0: 强制从第 0 张开始, 跟 loop: true 兼容
      //   - preventClicks: false: 不拦截 photo click, 走 onclick 调 fancybox
      //     注意: preventClicks 是顶层 config, 不能在 breakpoints 里覆盖
      //   - noSwipingClass: photo 跳过 swiping 拦截, 万一上面一个不够
      //   桌面端不受影响 (desktop slidesPerView=2 + 鼠标 click 不走 touchstart, swiper 不拦截)
      //   桌面端 breakpoints 显式关 centeredSlides (桌面 slidesPerView=2, 居中没意义还会挤)
      centeredSlides: true,
      initialSlide: 0,
      preventClicks: false,
      noSwipingClass: 'bjxy-event-photo',
      breakpoints: {
        768: {
          // v0.2.0h: tablet 768-1024, 2 卡
          slidesPerView: 2,
          // v0.2.0i.o: 桌面端关 centeredSlides (tablet slidesPerView=2, 居中没意义还会挤)
          centeredSlides: false,
          noSwipingClass: 'bjxy-event-photo'
        },
        1024: {
          // v0.2.0h: desktop >= 1024, 2 卡 (跟 tablet 一样, 显式分段方便后续单独调整)
          slidesPerView: 2,
          // v0.2.0i.o: desktop 关 centeredSlides
          centeredSlides: false,
          noSwipingClass: 'bjxy-event-photo'
        }
      },
      pagination: {
        el: vnode.dom.querySelector('.swiper-pagination'),
        clickable: true
      },
      // v0.1.6g: 自动轮播配置 (后台 bjxy_events_autoplay_ms, 默认 3000ms)
      autoplay: {
        delay: autoplayMs,
        disableOnInteraction: false
      }
    });
    // v0.2.0i.o 实战: 4 件套就够, 不需要 on.init slideToLoop 补丁
    //   之前试过 this.swiper.slideTo(0, 0) + on.init slideToLoop(0) 都被 swiper 11 loop normalize 覆盖
    //   实际 centeredSlides + loop 模式下:
    //     - DOM 顺序: [副本 (events[3]), events[0], events[1], events[2]]
    //     - activeIndex = 1, realIndex = 0
    //     - active slide (events[0]) 居中, x=17 width=356 在 viewport 内 ✅
    //     - mouse.click active slide photo → fancybox 弹 ✅
    //   注意: 测 photo 位置要查 .swiper-slide-active 里的 photo, 不是 DOM 第一个
    //     (DOM 第一个是 loop 副本, 永远在 viewport 左侧外)
  }

  // v0.1.30 改: 教练列表 swiper peek carousel (辉哥 11:08 反馈, 11:10 拍板 B 方案)
  //   - 经典 macOS App Store / iOS Music 风格: 1 张完整 + 0.2 张 peek
  //   - 复用 swiper 11 依赖 (v0.1.6 装 events 用), 跟 events section 同款 swiper pattern
  //   - 跟 this.swiper 独立 instance, onremove 各自 destroy
  initCoachSwiper(vnode) {
    if (!vnode || !vnode.dom) return;
    if (this.coachSwiper) this.coachSwiper.destroy(true, true);
    this.coachSwiper = new Swiper(vnode.dom, {
      // 不需要 Autoplay, 教练列表静态展示
      modules: [Navigation, Pagination],
      loop: true,
      // v0.2.0h 改: 显式分 3 段 viewport (辉哥 14:15 反馈, 跟 v0.1.38 768+ 跳 desktop 3 累计)
      //   mobile (< 768px) 1, tablet (768-1024) 2, desktop (>= 1024) 3
      //   swiper 11 breakpoints 触发 slidesPerView 切换, 跟 v0.1.30 swiper peek breakpoints 模式一致
      //   v0.1.38 改的 slidesPerView: 3 是 desktop 3 (768+ 跳 3), v0.2.0h 拆 tablet 2 + desktop 3
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          // v0.2.0h: tablet 768-1024, 2 卡 (新加, 之前 v0.1.38 跳 3 视觉太挤)
          slidesPerView: 2
        },
        1024: {
          // v0.2.0h: desktop >= 1024, 3 卡 (跟 v0.1.38 行为不变, 显式分段)
          slidesPerView: 3
        }
      },
      pagination: {
        el: vnode.dom.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }

  // 销毁 events swiper
  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  // 销毁教练 swiper
  // v0.1.30 改: 多 swiper instance, coach swiper 独立 destroy
  destroyCoachSwiper() {
    if (this.coachSwiper) {
      this.coachSwiper.destroy(true, true);
      this.coachSwiper = null;
    }
  }

  // 组件销毁时清理
  // v0.1.30 改: 多 swiper instance, events + coach 各自 destroy
  // v0.2.0i.i 新: 同步移 body.App-sidebar-aura-collapsed class
  //   切回 /d /u /all 等其他论坛路径时, sidebar 恢复 vendor 默认 (transform 折叠或展开)
  //   不移除 class 会导致其他页面 sidebar 永远 hidden
  onremove() {
    this.destroySwiper();
    this.destroyCoachSwiper();
    // v0.2.0i.i: 移 body class (配 oninit add)
    // v0.2.0i.n: 移 bjxy-page-active class + 兜底删老 <style id="bjxy-hide-mobile-tab"> 节点
    //   跟 oninit add bjxy-page-active 对应, 切回 /d /u /all 等路径时 body class 移除
    //   兜底删老节点: 兼容老 user 老 cache (deploy 前已经注入的 inline style 节点)
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('App-sidebar-aura-collapsed');
      // v0.2.0i.n: 移 page-level class
      document.body.classList.remove('bjxy-page-active');
      // v0.2.0i.n: 兜底删老 inline style 节点 (双保险, 兼容老 user 老 cache)
      const oldStyle = document.getElementById('bjxy-hide-mobile-tab');
      if (oldStyle) oldStyle.remove();
    }
    // v0.2.0i.k.b.6 改: 不清 sessionStorage bjxy active flag
    //   之前 v0.2.0i.k.b.3 设计是 onremove 清 active='0', 但这跟"刷新场景补 push"冲突
    //   实际场景:
    //     - bjxy → /u/wfl (SPA 内): 劫持同步 push bjxy, 然后 bjxy onremove 触发
    //       如果 onremove 清 active='0', 立即 page.reload 刷新 /u/wfl:
    //         setTimeout 0 check active='0' → 不补 push → 走 vendor 默认 back '/' 错误
    //     - bjxy → /d/1 → /u/wfl (SPA 内): 劫持 check app.previous 三重 check, 不依赖 active
    //       即使不清 active, app.previous='discussion' 也不会 push bjxy ✅
    //   结论: 不清 active, 严格依赖 app.previous 三重 check 修副作用
    //   风险: 用户在 bjxy → /d/1 → /u/wfl, sessionStorage active='1' 还在, 但劫持只 check app.previous='discussion', 不 push ✅
    //   好处: 刷新 /u/wfl 场景, sessionStorage active='1', setTimeout 0 fresh load 路径补 push ✅
  }
  view() {
    // v0.1.0l 修: extend.php 用 Extend\Settings::serializeToForum() 把 bjxy_* 加进
    //   forum.attributes, 前台 app.forum.attribute('bjxy_*') 直接拿到 (跟走 vendor 一样)
    //   之前 v0.1.0k 走 content() payload hack 失败 (container null), 现在用 vendor 正规 API
    const s = (key, fallback) => app.forum.attribute(key) || fallback;
    // v0.1.0s 改: curriculum 从 {single, double} 重构成 boards array
    //   兼容旧 data: 如果没 boards 字段但有 single/double, 自动转成 2 个 board
    const curriculumRaw = app.data && app.data.bjxyCurriculum || {};
    const curriculum = {
      boards: Array.isArray(curriculumRaw.boards) ? curriculumRaw.boards : [{
        name: '单板',
        levels: curriculumRaw.single || []
      }, {
        name: '双板',
        levels: curriculumRaw.double || []
      }]
    };
    const features = app.data && app.data.bjxyFeatures || [];
    // v0.1.6e 改: 过滤空 desc 的特色项, 避免 6+1 布局不平衡 (移动端 2 列变 3+3+1 孤零零)
    //   辉哥 14:04 反馈 "后台办学特色中的内容在移动端右侧出视界了"
    //   根因: 后台"添加特色"按钮会 push 一个空 desc 的占位项, 用户没填就保存, 布局不齐
    //   修法: 前端过滤 title 或 desc 为空的项, 不渲染; 6 项默认 = 桌面 2 行 3 列 + 移动 3 行 2 列 (整齐)
    const visibleFeatures = features.filter(f => f && f.title && f.desc);
    // v0.1.7a 改: 删 bjxy_reviews_html + bjxy_students_html fallback 读取
    //   老的 HTML 自由区字段已经废弃, 评价/活动统一用结构化 JSON
    // v0.1.6: 评价 + 学员结构化 JSON (替代 HTML 自由区)
    //   app.forum.attribute 拿 string, JSON.parse 转 array
    const reviews = (() => {
      const raw = s('bjxy_reviews', '[]');
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    })();
    // v0.1.6a: 学员 → 活动 (仍读 bjxy_students setting, 但展示为"活动")
    const events = (() => {
      const raw = s('bjxy_students', '[]');
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    })();

    // v0.1.0y: 背景渐变从 .bjxy-page block 背景, 抽到内部第一个 .bjxy-page-bg
    //   position: fixed; inset: 0 → 背景永远铺满 viewport (1vh), 不再随 body 拉长
    //   JS 监听 scroll 改 backgroundPositionY 0.1x → 滚动时背景微小视差移动
    //   (辉哥 15:21 反馈 "背景渐变不要从顶部到页面尾部, 维持在可视范围, 滚动时只有微小移动")
    // v0.1.0z: 加 2 个背景图 settings (走 ziven-core COS 上传)
    //   有图 → background: url(...), 渐变不生效 (图片优先级高)
    //   没图 → 4 色渐变生效 (v0.1.0j+y)
    const ls = s('bjxy_bg_gradient_light_start', '#E0EBF8') || '#E0EBF8';
    const le = s('bjxy_bg_gradient_light_end', '#F7FAFC') || '#F7FAFC';
    const ds = s('bjxy_bg_gradient_dark_start', '#0F1419') || '#0F1419';
    const de = s('bjxy_bg_gradient_dark_end', '#1A202C') || '#1A202C';
    const imgLight = s('bjxy_bg_image_light_url', '');
    const imgDark = s('bjxy_bg_image_dark_url', '');
    return [m('div', {
      class: 'bjxy-page',
      // v0.1.0y: 视差背景 div, position: fixed 在 viewport
      // 滚动 scrollY * 0.1 px → 背景 backgroundPositionY 反向微移
      oncreate: _ref => {
        let dom = _ref.dom;
        const bgEl = dom.firstElementChild;
        if (!bgEl || !bgEl.classList.contains('bjxy-page-bg')) return;
        this._bgParallax = () => {
          // v0.1.0aa 改: 渐变图 background-size 100% 300vh (比 viewport 大 3 倍)
          //   视差 0.1x scrollY 让背景从 div 顶部往上推 (Y 变成负值)
          //   viewport 永远看到渐变图 0-33% 区段 (起始色附近), 不会看到结束色
          const offset = window.scrollY * 0.1;
          bgEl.style.backgroundPositionY = "calc(0px - ".concat(offset, "px)");
        };
        window.addEventListener('scroll', this._bgParallax, {
          passive: true
        });
        this._bgParallax();
      },
      onremove: () => {
        if (this._bgParallax) {
          window.removeEventListener('scroll', this._bgParallax);
          this._bgParallax = null;
        }
      }
    }, [
    // v0.1.0y: 视差背景 div (固定在 viewport, JS 改 backgroundPositionY)
    m('div', {
      class: 'bjxy-page-bg'
    }),
    // v0.2.0i.aa.c.20 改 (辉哥 2026-09-01 09:26 反馈): 撤 c.19 全部 (vendor Navigation.items extend 注入), 改走 c.17 段 (BjxyPage.jsx view() 渲染 ul 包裹 + 隐藏 placeholder 触发 vendor :has + li 走 position: relative 治本 iOS 14+)
    //   现象 (辉哥 09:26 反馈): c.19 部署后 iPhone 真机亲测, 下拉刷新过程中 button 还是会跑 X 偏移
    //     辉哥反问: "如果真像你说的是完全一致, 为什么 bjxy 页面 top bar 的预约体验在下拉刷新时会向左移动, 而 https://bjxy.top/all 中 top bar 的发帖按钮就不会"
    //   根因 (Mavis 排查 /all vs c.19 渲染路径差异):
    //     - /all "开始讨论" 按钮走 vendor IndexSidebar.tsx 渲染路径:
    //       <nav.IndexPage-nav.sideNav><ul>{listItems(this.items().toArray())}</ul></nav>
    //       L77 classes.push(item.attrs?.itemClassName || item.itemClassName) — 读 button.attrs.itemClassName="App-primaryControl" 加到 li wrapper
    //       最终 DOM: ul.IndexPage-nav > li.item-newDiscussion.App-primaryControl > button.IndexPage-newDiscussion.hasIcon
    //       ul 内部有 2 个 .App-primaryControl (ziven-aura + vendor newDiscussion), 触发 vendor :has(> .App-primaryControl ~ .App-primaryControl) 选择器
    //       ul 走 position: fixed, 子 li 走 position: relative (vendor L74-77 段), iOS 14+ bug 不影响 relative
    //     - c.19 按钮走 vendor Navigation.items extend 注入路径:
    //       Navigation.tsx L34: {this.items().toArray()} — items 直接 toArray() 渲染, 不通过 listItems helper
    //       最终 DOM: div.Navigation.ButtonGroup > button — 没 li 包裹!
    //       没 ul 包裹 → vendor :has 选择器不触发 → button 自己走 vendor L29-37 段 position: fixed → iOS 14+ bug 影响
    //   修法 (c.20 治本 v3): 回到 c.17 段 (BjxyPage.jsx view() 渲染 ul 包裹 + 隐藏 placeholder 触发 :has + li 走 relative)
    //     - 撤 c.19 extend(Navigation.prototype, 'items', ...) 段
    //     - 改在 BjxyPage.jsx view() 渲染 <ul class="bjxy-mobile-cta-ul"> 内 <li class="bjxy-mobile-cta-li App-primaryControl item-newDiscussion"> <button class="Button Button--primary IndexPage-newDiscussion hasIcon"> ... </button> </li>
    //     - 加 1 个隐藏 placeholder <li class="App-primaryControl" style="display: none"> 触发 vendor :has(> .App-primaryControl ~ .App-primaryControl) 选择器
    //       vendor :has 看 DOM 结构, 不看 display 状态, 隐藏 li 仍然触发
    //     - button 走 vendor m('button', {...}, [i, span Button-label span Button-labelText]) 节点 (跟 /all 1:1 一样的 DOM 结构)
    //     - button 走 main.App-content 内部 (跟 /all 一样父链)
    //   联代性 trade-off (辉哥接受):
    //     - iOS 14+ 期间 li 不跑 X/Y (main.App-content + relative 不受 bug 影响), .App-backControl (在 #app-navigation 内部) 跑 X
    //     - 视觉短暂错位几 ms (跟 /all "开始讨论" 按钮一样行为, 辉哥 iPhone 真机亲测没报这个 bug)
    //   条件: 只 bjxy 路由 + 只 mobile viewport (桌面端不显示, 跟辉哥 17:06 拍板 A 方案一致)
    //   SOP 314 终极方案 (v12): iOS Safari 14+ 移动端顶 bar 适配 = button 走 main.App-content 内部 (BjxyPage.jsx view() 渲染) + 套 ul 包裹 + 隐藏 placeholder 触发 vendor :has + li 走 position: relative
    //   实战教训: 任何项目想在 mobile 端 top bar 右侧加 button, 走 "ul > li > button + 2 个 .App-primaryControl 触发 :has" 套路, 跟 /all 一样
    //   适用: 1 个 button 也要套 ul + 隐藏 placeholder, 才能走 vendor L63-78 段 li 走 relative 样式
    //   保留 c.18 段: button DOM 跟 /all 1:1 一致 (itemclassname="App-primaryControl" + Button-label 段 + icon fa-calendar-plus)
    //   撤 c.19 段: 不再走 vendor Navigation.items extend 注入路径, 改回 c.17 时代 BjxyPage.jsx 渲染
    typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 767px)').matches && app.forum.attribute('bjxy_hero_cta_enabled') !== false ? m('ul', {
      className: 'bjxy-mobile-cta-ul'
    }, [m('li', {
      className: 'bjxy-mobile-cta-li App-primaryControl item-newDiscussion'
    }, [m('button', {
      // c.20 改: button className 跟 /all 1:1 一致 (用 vendor 同样的 IndexPage-newDiscussion class)
      //   保留 c.16 段 .bjxy-mobile-cta 是 bjxy 视觉 class (蓝底白字), 不冲突可以共存
      className: 'Button Button--primary IndexPage-newDiscussion bjxy-mobile-cta hasIcon',
      type: 'button',
      'aria-label': app.forum.attribute('bjxy_hero_cta_text') || '预约体验',
      // c.20 改: 加 itemclassname 属性 (vendor listItems 内部属性, /all 1:1 一致)
      itemclassname: 'App-primaryControl',
      onclick: () => {
        // c.20 改: onclick 改 BookingModal (代替 /all 默认的 IndexPage new discussion flow)
        app.modal.show(BookingModal);
      }
    }, [
    // c.20 改: icon 改 fa-calendar-plus ("添加预约" 意思, /all 那个用 fa-edit "发新讨论" 意思)
    m('i', {
      className: 'icon fas fa-calendar-plus Button-icon',
      'aria-hidden': 'true'
    }),
    // c.20 改: button 内部加 <span class="Button-label"><span class="Button-labelText">预约体验</span></span> 段 (跟 /all 1:1)
    //   vendor .App-primaryControl .Button-label default display: none, 视觉只 icon 风格 (保留 c.16 段)
    m('span', {
      className: 'Button-label'
    }, [m('span', {
      className: 'Button-labelText'
    }, app.forum.attribute('bjxy_hero_cta_text') || '预约体验')])])]),
    // v0.2.0i.aa.c.20 保留 (跟 c.17 段): 隐藏 placeholder li 触发 vendor :has(> .App-primaryControl ~ .App-primaryControl) 选择器
    //   ul 走 vendor L63-78 段: position: fixed, z-index 1001, top 0, right 0 (mobile .affix)
    //   子 .App-primaryControl 走 vendor L74-77 段: position: relative !important; right: auto;
    //   iOS 14+ bug 影响 fixed 元素, 不影响 relative 元素 → li 视觉稳定 (跟 /all 一样)
    //   placeholder li display: none 不影响视觉
    //   vendor :has 选择器看 DOM 结构, 不看 display 状态, 隐藏 li 仍然触发 :has
    m('li', {
      className: 'App-primaryControl',
      style: {
        display: 'none'
      },
      'aria-hidden': 'true'
    })]) : null,
    // ===== 导航 =====
    // v0.2.0i.aa.b 删 (辉哥 2026-08-31 16:46 拍板 A 方案): 删整个 bjxy 自建导航 (logo + 7 锚点 + 预约体验按钮)
    //   现象: 16:21 辉哥反馈 bjxy.top /bjxy 顶部跟 /all 不一致, bjxy 顶部还是 bjxy-nav (北极雪屿 logo + 7 锚点 + 蓝色预约体验按钮), 不是 vendor Flarum 原生 top bar
    //   根因: v0.2.0i.aa 撤回调 (15:30 reset --hard 9e29993) 只撤 v0.2.0i.aa 7 commits, 没撤 v0.1.9 时代就有的 bjxy-nav (v0.2.0i.aa 6 commits 第一个 commit 82662f1 才是删 bjxy-nav, 撤回调丢了)
    //   修法: 删整个 m() 块 (原 L402-L449) + 配套 less 段 (bjxy-nav / bjxy-logo / bjxy-logo-img / bjxy-logo-fallback / bjxy-logo-slogan / bjxy-nav-links / bjxy-nav-right / bjxy-theme-toggle / bjxy-btn / bjxy-btn-primary / bjxy-btn-outline 11 段)
    //     + mobile 段 .bjxy-nav / .bjxy-nav-links 2 段
    //   效果: bjxy 顶部完全走 vendor Flarum 原生 top bar (跟 /all 一致, 桌面 vendor App-header + 移动 vendor drawer),
    //     7 锚点 (关于/活动/特色/教学/教练/评价/联系) 删了, 用户从顶部滚到底部顺序看 section (跟 v0.1.9 之前无 nav 时代一致)
    //   配套: less 段之前是 bjxy-nav 死代码的 (v0.2.0i.n 时代 #header hide + #app padding-top 63.8) 已经在 v0.2.0i.aa.a 删了
    //   适用: 任何项目改"自建 nav 替换 vendor nav"方向时, 撤回要同时撤 nav 渲染 + 配套 less 段, 避免死代码

    // ===== 8 主体 section (顺序由 bjxy_section_order_json 决定) =====
    // v0.1.9: 重构成 renderXxxSection() 函数 + 按 order 遍历
    //   之前 v0.1.6b 沉淀: hero → about → events → features → curriculum → coach → reviews → contact
    //   现在从 bjxy_section_order_json 读顺序 (后台可拖拽调整)
    //   brand/bg 是全局设置不渲染独立 section, footer 永远最底
    this.getSectionOrder().map(k => this.renderSectionByKey(k, {
      s,
      events,
      reviews,
      visibleFeatures,
      curriculum
    })),
    // ===== footer (永远在最底, 不参与排序) =====
    // v0.1.0ab 改: 备案号从 bjxy_icp_number setting 读 (后台可设)
    //   留空时 fallback 到默认 '2026xxxxxx' (跟之前 hard-coded 一致, 兼容旧部署)
    // v0.1.2 改: 加 公安备案号 + 网安链接 (国家规定中国大陆站点 footer 必须有)
    //   留空时不渲染公安备案行 (避免显示空链接)
    // v0.1.15 改: 走 isSectionVisible('footer') 判断, 关闭时不渲染整个 footer
    this.isSectionVisible('footer') ? m('footer', {
      class: 'bjxy-footer'
    }, [m('div', {
      class: 'bjxy-footer-line'
    }, '© ' + new Date().getFullYear() + ' ' + s('bjxy_brand_name', DEFAULT_BRAND) + ' · ICP 备 ' + (s('bjxy_icp_number', '2026xxxxxx') || '2026xxxxxx') + ' 号'), s('bjxy_police_number') ? m('div', {
      class: 'bjxy-footer-line'
    }, [m('img', {
      class: 'bjxy-footer-police-icon',
      src: 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="14" height="14"><path fill="#fff" d="M10 1l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V4l8-3zm0 2.2L4 5.4V10c0 4 2.7 6.8 6 7.3 3.3-.5 6-3.3 6-7.3V5.4l-6-2.2zM7 8h6v1H7V8zm0 2h6v1H7v-1zm0 2h4v1H7v-1z"/></svg>'),
      alt: '公安备案'
    }), ' ', m('a', {
      href: s('bjxy_police_link', 'http://www.beian.gov.cn/portal/registerSystemInfo') || 'http://www.beian.gov.cn/portal/registerSystemInfo',
      target: '_blank',
      rel: 'noopener noreferrer',
      class: 'bjxy-footer-link'
    }, '京公网安备 ' + s('bjxy_police_number', '') + ' 号')]) : null]) : null
    // v0.2.0r.j 删 (辉哥 8/29 08:13 拍板 A 续): 不再需要 bjxy-page-spacer 占位段
    //   真根因找到: vendor App-footer 自身 display block 占 20px line-height 拉出 visualGap, 不是 bjxy 短
    //   修法改成 less 段 hide footer.App-footer (display: none), bjxy 末尾直接贴 viewport 底, 不用 spacer 撑高
    //   配套: less/forum.less @media @phone 段加 footer.App-footer { display: none !important; }
    ])];
  }

  // v0.1.9: 读 bjxy_section_order_json 解析成数组, 过滤掉 brand/bg/footer
  //   防御: 解析失败 / 不是数组 / 数组里 key 不对时 fallback 到默认顺序
  // v0.1.15 改: 额外过滤掉 visible=false 的 section (走 bjxy_section_visible_<key> setting)
  //   辉哥 18:19 拍板: "只有在开启时前端对应的section才展示"
  //   footer 单独判断 (走 isSectionVisible('footer') 控制, 不参与主 section 列表)
  getSectionOrder() {
    const DEFAULT_SECTION_ORDER = ['hero', 'about', 'events', 'features', 'curriculum', 'coach', 'reviews', 'contact'];
    const raw = app.forum.attribute('bjxy_section_order_json');
    if (!raw) return DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k));
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        // 过滤掉 brand / bg / footer (这 3 个不渲染独立 section) + visible=false 的
        const mainSections = parsed.filter(k => k !== 'brand' && k !== 'bg' && k !== 'footer').filter(k => this.isSectionVisible(k));
        // 验证剩下 8 个主体 section key 都有
        if (mainSections.length === DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k)).length) {
          const validKeys = DEFAULT_SECTION_ORDER;
          const allValid = mainSections.every(k => validKeys.indexOf(k) >= 0);
          if (allValid) return mainSections;
        }
      }
    } catch (e) {}
    return DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k));
  }

  // v0.1.15: 判断 section 是否可见 (读 bjxy_section_visible_<key> setting)
  //   默认 true (旧部署缺 setting 时全部展示, 跟开关默认开启一致)
  //   '1' / 'true' / true 算可见; 其他 (含 '0' / 'false' / 缺省) 算可见 (默认)
  isSectionVisible(key) {
    const v = app.forum.attribute('bjxy_section_visible_' + key);
    if (v === '0' || v === 'false' || v === false) return false;
    return true; // 默认可见 (跟 oninit 默认一致, 兼容旧部署)
  }

  // v0.1.9: 按 key 调用对应 renderXxxSection 方法
  //   跟 v0.1.6b 沉淀的 section class 一致: hero/约/features/curriculum 走 alt, 其他走 normal
  //   保留 v0.1.6b section 顺序: about(events 移走) → events 跟 alt 交替
  //   hero 是 page 顶部特殊 section (跟其他 section 视觉差异大), 不走 bjxy-section/bjxy-section-alt
  renderSectionByKey(key, ctx) {
    const s = ctx.s,
      events = ctx.events,
      reviews = ctx.reviews,
      visibleFeatures = ctx.visibleFeatures,
      curriculum = ctx.curriculum;
    switch (key) {
      case 'hero':
        return this.renderHeroSection(s);
      case 'about':
        return this.renderAboutSection(s);
      case 'events':
        return this.renderEventsSection(events, s);
      // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): 3 个 renderSection 都加 s 参数 (s() helper 用来读 bjxy_section_label_*)
      case 'features':
        return this.renderFeaturesSection(visibleFeatures, s);
      case 'curriculum':
        return this.renderCurriculumSection(curriculum, s);
      case 'coach':
        return this.renderCoachSection(s);
      case 'reviews':
        return this.renderReviewsSection(reviews, s);
      case 'contact':
        return this.renderContactSection(s);
      default:
        return null;
    }
  }

  // v0.1.9: 8 主体 section 渲染方法 (从 view() 提取)
  //   每个方法返回 1 个 m() 节点, 跟 v0.1.6b 沉淀的 HTML 结构 1:1 一致

  // Hero
  renderHeroSection(s) {
    return m('section', {
      class: 'bjxy-hero',
      id: 'hero',
      key: 'sec-hero'
    }, [m('div', {
      class: 'bjxy-hero-text'
    }, [m('h1', null, [s('bjxy_hero_title', '探索极致的滑雪体验。')]), m('p', null, s('bjxy_hero_subtitle', '专注滑雪领域的全国连锁机构, 17 级渐进教学体系 + 认证教练 + 全国品牌机构。')), m('div', {
      class: 'bjxy-hero-features'
    }, [m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_1_num', '10+')), ' ' + s('bjxy_about_stat_1_label', '年教学经验')]), m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_2_num', '50+')), ' ' + s('bjxy_about_stat_2_label', '专业教练')]), m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_3_num', '1000+')), ' ' + s('bjxy_about_stat_3_label', '毕业学员')])])]), m('div', {
      class: 'bjxy-hero-banner'
    }, [s('bjxy_hero_banner_light') ? m('img', {
      class: 'bjxy-hero-banner-light',
      src: s('bjxy_hero_banner_light'),
      alt: 'Hero'
    }) : null, s('bjxy_hero_banner_dark') ? m('img', {
      class: 'bjxy-hero-banner-dark',
      src: s('bjxy_hero_banner_dark'),
      alt: 'Hero Dark'
    }) : null, !s('bjxy_hero_banner_light') && !s('bjxy_hero_banner_dark') ? m('div', {
      class: 'bjxy-hero-banner-fallback'
    }, [m('div', {
      class: 'bjxy-hero-banner-fallback-name'
    }, s('bjxy_brand_name', DEFAULT_BRAND)), m('div', {
      class: 'bjxy-hero-banner-fallback-slogan'
    }, s('bjxy_brand_slogan', DEFAULT_SLOGAN))]) : null])]);
  }

  // 关于
  renderAboutSection(s) {
    return m('section', {
      class: 'bjxy-section',
      id: 'about',
      key: 'sec-about'
    }, [m('div', {
      class: 'bjxy-sub'
    }, s('bjxy_about_sub', 'ABOUT US')),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_about, 跟后台 '关于我们' tab 联动
    //   之前用 bjxy_about_title 单独字段, 现在统一走 bjxy_section_label_<key> 跟其他 5 个 section 一致
    m('h2', null, s('bjxy_section_label_about', '关于北极雪屿')),
    // v0.2.0d (辉哥 11:55 反馈): bjxy_about_desc 支持 HTML 渲染
    // admin 走 textareaField (不变, 支持输入 HTML), 前端用 m.trust() 渲染 HTML
    // 改 <p> → <div> 是因为 m.trust 可能包含多行 HTML (h1/h2/ul 等), p 不能嵌套块级元素
    // 加 .bjxy-about-desc class 方便 less 调样式 + XSS 防护走 admin 权限 (有 bjxy_about_desc 字段写入权限的人 = admin user)
    m('div', {
      class: 'bjxy-about-desc'
    }, m.trust(s('bjxy_about_desc', '北极雪屿室内滑雪成立于 2024 年, 专注滑雪领域的全国连锁机构...'))), m('div', {
      class: 'bjxy-stats'
    }, [m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_1_num', '10+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_1_label', '年教学经验'))]), m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_2_num', '50+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_2_label', '专业教练'))]), m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_3_num', '1000+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_3_label', '毕业学员'))])])]);
  }

  // 活动展示
  // v0.1.6b 改: 从尾部移到关于下方 (v0.1.9 现在按 order 决定位置)
  // v0.1.6d: 活动展示支持点击跳转 URL
  renderEventsSection(events, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'events',
      key: 'sec-events'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'EVENTS'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_events, 跟后台 '活动展示' tab 联动
    m('h2', null, s('bjxy_section_label_events', '活动展示')), events.length > 0 ? m('div', {
      class: 'bjxy-event-swiper swiper',
      oncreate: vnode => this.initSwiper(vnode)
    }, [m('div', {
      class: 'swiper-wrapper'
    }, events.map((ev, i) => {
      const photos = Array.isArray(ev.photos) ? ev.photos : ev.photoUrl ? [ev.photoUrl] : [];
      const firstPhoto = photos[0];
      const url = (ev.url || '').trim();
      const isInternal = url.startsWith('/') && !url.startsWith('//');
      const hasUrl = url.length > 0;
      return m('div', {
        class: 'swiper-slide bjxy-event-slide',
        key: 'ev' + i
      }, [firstPhoto ? hasUrl ? isInternal ? m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        href: url,
        onclick: e => {
          e.preventDefault();
          m.route.set(url);
        }
      }) : m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }) : m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        onclick: e => {
          e.preventDefault();
          this.openFancyboxGallery(photos, 0);
        }
      }) : m('div', {
        class: 'bjxy-event-photo bjxy-event-photo-empty'
      }), hasUrl ? isInternal ? m('a', {
        class: 'bjxy-event-info bjxy-event-link',
        href: url,
        onclick: e => {
          e.preventDefault();
          m.route.set(url);
        }
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null]) : m('a', {
        class: 'bjxy-event-info bjxy-event-link',
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null]) : m('div', {
        class: 'bjxy-event-info'
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null])]);
    })), m('div', {
      class: 'swiper-pagination'
    })]) : m('p', null, '（暂无活动展示, 请在后台添加）')]);
  }

  // 特色
  // v0.1.6h: 改玻璃拟态 (辉哥 16:06 选 A 方案)
  // v0.1.33 改 (辉哥 14:38 反馈):
  //   桌面端改 Bento 网格 (前 2 个 bjxy-feature-large + 后 4 个常规, 6 列 grid span 3 / span 2)
  //   移动端保持 1 列堆叠 (less @phone media query)
  //   每条支持背景图 + 黑色遮罩层 (opacity 走 bjxy_feature_card_overlay_opacity setting, 默认 0.5)
  //   有背景图时文字改白 (黑遮罩后深色文字看不清)
  renderFeaturesSection(visibleFeatures, s) {
    const overlayOpacity = parseInt(app.forum.attribute('bjxy_feature_card_overlay_opacity') || '50', 10) / 100;
    return m('section', {
      class: 'bjxy-section bjxy-section-alt bjxy-features-glass',
      id: 'features',
      key: 'sec-features'
    }, [m('div', {
      class: 'bjxy-section-head'
    }, [m('div', {
      class: 'bjxy-features-eyebrow'
    }, 'Why Choose Us'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_features
    //   之前是 hardcode '为什么选择北极雪屿' 跟后台 '办学特色' tab 不一致, 现在同步
    m('h2', null, s('bjxy_section_label_features', '办学特色')), m('p', {
      class: 'bjxy-features-sub'
    }, '从环境到教练, 从课程到装备, 每一个细节都为你精心准备')]), m('div', {
      class: 'bjxy-feature-grid'
    }, visibleFeatures.map((f, i) => m('div', {
      class: 'bjxy-feature' + (i < 2 ? ' bjxy-feature-large' : ''),
      key: 'f' + i
    }, [
    // v0.1.33 改: 背景图 (可选) + 黑色遮罩层 (opacity 走 setting)
    f.bgImageUrl ? m('div', {
      class: 'bjxy-feature-bg'
    }, [m('img', {
      src: f.bgImageUrl,
      alt: ''
    }), m('div', {
      class: 'bjxy-feature-mask',
      style: 'opacity: ' + overlayOpacity
    })]) : null, m('div', {
      class: 'bjxy-feature-content'
    }, [
    // v0.1.35 删: 数字编号 01-06 span (辉哥 17:12 反馈去掉每个卡片的数字编号)
    // v0.1.36 删: bjxy-feature-icon 渲染 (辉哥 21:52 反馈去掉 feature icon)
    //   后台 BjxySettings.jsx 也删了 icon 输入字段, less 也删了 .bjxy-feature-icon 整段 + ::after + 大卡 reset + mobile 段 reset + 有 bg 白字
    //   f.icon 字段 data schema 保留 (兼容老数据, 序列化 L1150 / 反序列化 L1535 不动)
    m('h3', null, f.title || ''), m('p', null, f.desc || '')])])))]);
  }

  // 教学体系
  // v0.1.0s 改: boards 数组任意多类型
  // v0.2.0h (返工) 改 (辉哥 2026-08-10 19:00 反馈, 教学卡片简单 :hover 改 scroll 动画):
  //   之前 :hover 触发蓝边 + translateY, 辉哥要"随着下面下拉, 每个卡片边框逐一展示/消失"
  //   改: IntersectionObserver 监听 .bjxy-level-card, 进入 viewport 50% 时 add .bjxy-level-card--visible
  //   (border-color 蓝 + opacity 1, 0.4s ease 过渡), 退出时 remove (回 opacity 0.5)
  //   关键 SOP 158: onremove cleanup observer.disconnect() 避免内存泄漏 (card DOM 被 mithril 移除后 observer 还引用)
  //   tab 切换 activeBoard: mithril 复用 .bjxy-curri-list 容器, 但 children (cards) 全换, onupdate 重 observe 新 cards
  //   跟 .bjxy-coach-swiper (v0.1.30 peek) 模式不同 — curriculum cards 是 grid 不是 carousel
  setupLevelObserver(dom) {
    if (!dom) return;
    if (dom._levelObserver) {
      dom._levelObserver.disconnect();
      dom._levelObserver = null;
    }
    const cards = dom.querySelectorAll('.bjxy-level-card');
    if (cards.length === 0) return;
    // rootMargin '0px 0px -50% 0px' = 视口底部 50% 收缩 (卡片进入 viewport 顶部 50% 区域才触发)
    // threshold 0 = 卡片跟 rootMargin 重叠就触发 (默认)
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bjxy-level-card--visible');
        } else {
          entry.target.classList.remove('bjxy-level-card--visible');
        }
      });
    }, {
      rootMargin: '0px 0px -50% 0px',
      threshold: 0
    });
    cards.forEach(card => observer.observe(card));
    dom._levelObserver = observer;
  }
  renderCurriculumSection(curriculum, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'curriculum',
      key: 'sec-curriculum'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'CURRICULUM'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_curriculum
    //   整个 string 都可改 (因为带数字 <n> 级教学体系, 整个写进 setting 更简单)
    //   fallback 保留数字 + '级教学体系' 跟之前一致 (跟 tab '教学体系' 配套)
    m('h2', null, s('bjxy_section_label_curriculum', curriculum.boards.reduce((sum, b) => sum + b.levels.length, 0) + ' 级教学体系')), m('div', {
      class: 'bjxy-curri-tabs'
    }, [curriculum.boards.map((b, i) => m('div', {
      class: 'bjxy-curri-tab' + (this.activeBoard === i ? ' active' : ''),
      onclick: () => {
        this.activeBoard = i;
      },
      key: 'tab' + i
    }, b.name + ' (' + b.levels.length + ' 级)'))]),
    // v0.2.0h (返工) 改: .bjxy-curri-list 加 oncreate/onupdate/onremove 管理 IntersectionObserver
    //   oncreate 初次渲染时 observe 当前 activeBoard 的所有 cards
    //   onupdate 每次 activeBoard 切换 (mitthril re-render) 时 disconnect 老的 + observe 新的
    //   onremove 卸载时 cleanup observer.disconnect() 防内存泄漏 (SOP 158 模式)
    m('div', {
      class: 'bjxy-curri-list',
      oncreate: _ref2 => {
        let dom = _ref2.dom;
        return this.setupLevelObserver(dom);
      },
      onupdate: _ref3 => {
        let dom = _ref3.dom;
        return this.setupLevelObserver(dom);
      },
      onremove: _ref4 => {
        let dom = _ref4.dom;
        if (dom && dom._levelObserver) {
          dom._levelObserver.disconnect();
          dom._levelObserver = null;
        }
      }
    }, (curriculum.boards[this.activeBoard] ? curriculum.boards[this.activeBoard].levels : []).map((l, i) => m('div', {
      class: 'bjxy-level-card',
      key: 'c' + i
    }, [m('div', {
      class: 'bjxy-level-num'
    }, 'Lv ' + (i + 1)), m('div', {
      class: 'bjxy-level-lvl'
    }, l.level || ''), m('div', {
      class: 'bjxy-level-name'
    }, l.name || ''), m('div', {
      class: 'bjxy-level-desc'
    }, l.desc || '')])))]);
  }

  // 教练
  // v0.1.5: 加 bio + achievements + specialties + photoUrl
  // v0.1.30 改: 改用 swiper 11 peek carousel (辉哥 11:08 反馈, 11:10 拍板 B 方案)
  //   - 删 v0.1.28/v0.1.29 CSS scroll-snap 容器, 改用 swiper 11 instance (跟 events section 同款 pattern)
  //   - desktop slidesPerView 1.2 (1 张完整 + 0.2 张 peek ≈ 100px), mobile breakpoints 1.1
  //   - 保留 v0.1.27 SOP 155 沉淀: 3 张卡片统一详细样式, alice/bob 没字段不显示空白
  renderCoachSection(s) {
    return m('section', {
      class: 'bjxy-section',
      id: 'coach',
      key: 'sec-coach'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'COACHES'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_coach
    //   之前 hardcode '专业教练', 辉哥本意可以改成 '教练团队' 等
    m('h2', null, s('bjxy_section_label_coach', '专业教练')), this.loadingCoaches ? m('p', null, '加载中...') : this.coaches.length === 0 ? m('p', null, '（暂无教练, 请在后台选择用户组）') : m('div', {
      class: 'bjxy-coach-swiper swiper',
      oncreate: vnode => this.initCoachSwiper(vnode)
    }, [m('div', {
      class: 'swiper-wrapper'
    }, this.coaches.map((c, i) => m('div', {
      class: 'swiper-slide bjxy-coach-slide',
      key: 'c' + i
    }, [
    // v0.1.27 改 (A 方案): 删原来的 detail 二分判断, 所有 coach 统一走详细卡片样式
    //   没字段的字段 (bio/achievements/specialties) 在下方三元判断自动隐藏, 不显示空白
    // v0.2.0g 改: fof-user-bio 写了时, .bjxy-coach 加 bjxy-coach--has-fof-user-bio BEM 修饰符
    //   配合 less 条件式选择器 .bjxy-coach:not(.bjxy-coach--has-fof-user-bio) .bjxy-coach-bio { border-top: ... }
    //   fof-user-bio 写了时: 隐藏 bio border-top 分割线 (下方没 specialties/achievements 段, 分割线没意义)
    //   fof-user-bio 没写时: 保留分割线 (下方有 specialties/achievements 段, 分割线分隔)
    //   辉哥 13:33 反馈: "还有个分割线的残留, 如果填了 fof user bio 的话这个分割线也去掉吧"
    m('div', {
      class: 'bjxy-coach' + (c.bio_from_fof_user_bio ? ' bjxy-coach--has-fof-user-bio' : ''),
      // v0.2.0i.j 新 (辉哥 2026-08-12 10:07 反馈): 教练卡片 click 跳转 /u/{username} 用户页面
      //   修 v0.1.0 历史 feature gap: 之前 .bjxy-coach div 没绑 onclick, 点击无反应
      //   BjxyCoachModal.jsx 存在但没人调用 (保留, 跟现在 onclick 跳转共存不影响)
      //   跳 mithril 路由 /u/{username} 走 vendor Forum user page 渲染
      //   swiper 11 拖动 vs click 不冲突: swiper 默认 preventClicks: false, short tap 触发 click, long press 触发拖动
      //   mithril 0.2.x m() div 加 onclick 直接生效, 不用 wrap <a> 避免 vendor LinkButton 副作用
      //   5 教练卡片 [6,7,5,8,1] → /u/wfl /u/hyw /u/zsj /u/dsl /u/Ziven (跟 bjxy_coach_user_ids 顺序一致)
      //   路由切换: /bjxy unmount (onremove 跑 body class remove) → vendor user page 渲染, OK
      onclick: () => m.route.set('/u/' + c.username)
    }, [
    // v0.1.36a 改回: 横向布局 (辉哥 22:15 反馈)
    //   辉哥本意: avatar 单独在左, name + username 跟在 avatar 下方, info 还是在右侧
    //   v0.1.36 Coder 改成全 vertical 堆叠是错的, 现在拆 .bjxy-coach-left column 包 avatar + meta
    //   info (.bjxy-coach-info) 单独放在 .bjxy-coach-left 右侧
    m('div', {
      class: 'bjxy-coach-left'
    }, [m('div', {
      class: 'bjxy-coach-avatar'
    }, [
    // v0.1.10 改: 用用户自己的系统头像 (user.avatar_url 走 vendor User::getAvatarUrlAttribute() accessor 拼 URL)
    //   + srcset 走 2x/3x 让 Retina 屏幕清晰
    c.avatarUrl ? m('img', {
      src: c.avatarUrl,
      srcset: c.avatarSrcset || null,
      alt: c.displayName,
      loading: 'lazy'
    }) : (c.displayName || '?').charAt(0)]),
    // v0.1.36a 保留: name + username 单独块, 跟 avatar 间距 12px (新加 .bjxy-coach-left column 模式)
    //   辉哥 21:52 反馈: 教练 name/username 放到头像下方, 跟头像保持合适的间距
    m('div', {
      class: 'bjxy-coach-meta'
    }, [m('div', {
      class: 'bjxy-coach-name'
    }, c.displayName || ''), c.username ? m('div', {
      class: 'bjxy-coach-username'
    }, '@' + c.username) : null])]), m('div', {
      class: 'bjxy-coach-info'
    }, [
    // v0.1.36 删: name + username (移到 .bjxy-coach-left 内 .bjxy-coach-meta 块)
    // v0.1.36a 保留: info 单独放在右侧, 跟 .bjxy-coach-left (avatar+meta) 平行
    c.specialties ? m('div', {
      class: 'bjxy-coach-specialties'
    }, [m('span', {
      class: 'bjxy-coach-label'
    }, '🏂 专长'), m('span', {
      class: 'bjxy-coach-text'
    }, c.specialties)]) : null, c.achievements ? m('div', {
      class: 'bjxy-coach-achievements'
    }, [m('span', {
      class: 'bjxy-coach-label'
    }, '🏆 成就'), m('span', {
      class: 'bjxy-coach-text'
    }, c.achievements)]) : null,
    // v0.2.0h (返工) 改 (辉哥 2026-08-10 19:00 反馈, bio 渲染跟 fof user bio 不一致):
    //   之前 v0.2.0h (第一次) 走 oncreate + onupdate client-side s9e.TextFormatter.preview (跟 ComposerPostPreview 同模式)
    //   跟 fof user bio /u/Ziven 走的 server-side pre-rendered safe HTML (m.trust 渲染) 不同时机, 视觉有差
    //   (s9e preview 重新 wrap <p> + 加 <br> 位置跟 vendor render 不完全一致, emoji twemoji img 位置也有差)
    //   现在改成 server 端预渲染 (CoachesController 加 bioHtml 字段), 前端 m.trust(c.bioHtml) 直接拿 safe HTML
    //   跟 /u/Ziven 个人页 fof user bio 渲染模式完全一致 (DOM tree <p> / <br> / img.emoji 数量 + textContent 一致)
    //   XSS 防护: bioHtml 已经过 UserBioFormatter->render() (s9e parser 自动 escape 不安全 HTML 标签), 跟 v0.2.0d about_desc 一致
    //   c.bio 字段保留 (API 仍返 plain text) 供后续可能用 (如 alert / notification / search)
    c.bioHtml ? m('div', {
      class: 'bjxy-coach-bio'
    }, m.trust(c.bioHtml)) : null])])]))), m('div', {
      class: 'swiper-pagination'
    })])]);
  }

  // 评价
  // v0.1.6a: 大众点评风格 评价+图片
  renderReviewsSection(reviews, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'reviews',
      key: 'sec-reviews'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'REVIEWS'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_reviews
    m('h2', null, s('bjxy_section_label_reviews', '学员评价')), reviews.length > 0 ? m('div', {
      class: 'bjxy-review-grid'
    }, reviews.map((r, i) => {
      const photos = Array.isArray(r.photos) ? r.photos : r.photoUrl ? [r.photoUrl] : [];
      return m('div', {
        class: 'bjxy-review',
        key: 'r' + i
      }, [m('div', {
        class: 'bjxy-review-stars'
      }, this.renderStars(r.rating || 5)), m('div', {
        class: 'bjxy-review-quote'
      }, r.text || ''), m('div', {
        class: 'bjxy-review-author'
      }, [m('span', {
        class: 'bjxy-review-author-av'
      }, (r.author || '?').charAt(0)), m('span', null, r.author || '匿名'), r.date ? m('span', {
        class: 'bjxy-review-date'
      }, ' · ' + r.date) : null]), photos.length > 0 ? m('div', {
        class: 'bjxy-review-photos'
      }, photos.map((url, pi) => m('a', {
        key: 'rp' + i + 'p' + pi,
        class: 'bjxy-review-photo',
        style: {
          backgroundImage: 'url(' + url + ')'
        },
        onclick: e => {
          e.preventDefault();
          this.openFancyboxGallery(photos, pi);
        }
      }))) : null]);
    })) : m('p', null, '（暂无评价, 请在后台添加）')]);
  }

  // 联系
  // v0.1.32 改: 4 字段 → 3 字段 (辉哥 11:48 反馈)
  //   - 地址 改多地址 (1-3 个卡片, 复用 reviews array 模式)
  //   - 微信 改多图 (3 列缩略图墙, 复用 reviews photos 模式)
  //   - 邮箱 完全删 (前台 + 后台都不渲染)
  //   - 电话 保留单值
  //   - 向后兼容: 旧 bjxy_contact_address 单值 → 多地址迁移, 旧 bjxy_contact_wechat 文字值不迁移 (不能当图)
  renderContactSection(s) {
    // 解析多地址 (array of {value} → array of string)
    const addresses = (() => {
      try {
        const raw = s('bjxy_contact_addresses', '[]');
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          return arr.map(a => typeof a === 'string' ? a : a && a.value || '').filter(Boolean);
        }
      } catch (e) {}
      // 向后兼容: 旧 bjxy_contact_address 单值 → [old]
      const old = s('bjxy_contact_address', '');
      return old ? [old] : [];
    })();
    // 解析多图微信 (array of URL)
    const wechatImages = (() => {
      try {
        const raw = s('bjxy_contact_wechat_images', '[]');
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    })();
    return m('section', {
      class: 'bjxy-section',
      id: 'contact',
      key: 'sec-contact'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'CONTACT'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_contact
    // v0.5.10.c 撤 (辉哥 2026-08-30 23:44 反馈): 删 v0.5.10.a.b 加的 .bjxy-contact-header flex 包 h2 + "测试" 按钮
    //   iPhone 真机亲测后确认: Flarum 2.0 原生 modal 自身 bug, 不管 BookingModal 还是 TestModal 都跳顶
    //   "测试" 按钮本身是临时调试用, 调试结论出来后没用了, 撤
    m('h2', null, s('bjxy_section_label_contact', '联系我们')), m('p', {
      class: 'bjxy-section-desc'
    }, '有任何问题, 欢迎随时联系, 我们 24 小时内回复'), m('div', {
      class: 'bjxy-contact-grid'
    }, [
    // v0.2.0i 新加: B 方案左大图 (mobile only, desktop 默认 display: none)
    //   蓝渐变 + ⛰ emoji 占位 + meta 段 (跟 B_left_image.html 一致)
    m('div', {
      class: 'bjxy-contact-image',
      key: 'image'
    }, [m('div', {
      class: 'bjxy-contact-image-inner'
    }, [m('div', {
      class: 'bjxy-contact-image-mock'
    }), m('div', {
      class: 'bjxy-contact-image-meta'
    }, [m('div', {
      class: 'bjxy-contact-image-eyebrow'
    }, 'VISIT US'), m('div', {
      class: 'bjxy-contact-image-title'
    }, '大型滑雪模拟机 · 室内四季恒温'), m('div', {
      class: 'bjxy-contact-image-sub'
    }, '营业时间 10:00 - 22:00')])])]),
    // v0.2.0i 改: 段从 .bjxy-contact-item 卡片 → .bjxy-contact-segment 扁平段 (辉哥 15:12 反馈, 不要卡片式)
    //   地址 (多地址, 段内多行, 跟 A_flat_list_desktop 一致)
    m('div', {
      class: 'bjxy-contact-segment',
      key: 'address'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '地址 · ADDRESS'), m('div', {
      class: 'bjxy-contact-value'
    }, addresses.length > 0 ? addresses.map((addr, i) => m('span', {
      class: 'bjxy-contact-value-item',
      key: 'addr-' + i
    }, addr)) : m('span', {
      class: 'bjxy-contact-value-item'
    }, '敬请期待'))]),
    // 电话 (单值保留)
    m('div', {
      class: 'bjxy-contact-segment',
      key: 'phone'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '电话 · PHONE'), m('div', {
      class: 'bjxy-contact-value'
    }, s('bjxy_contact_phone', '400-888-8888'))]),
    // 微信 (多图, 走 40x40 thumbnail 紧凑 flex 布局)
    wechatImages.length > 0 ? m('div', {
      class: 'bjxy-contact-segment bjxy-contact-wechat',
      key: 'wechat'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '微信 · WECHAT'), m('div', {
      class: 'bjxy-contact-wechat-grid'
    }, wechatImages.map((url, i) => m('a', {
      class: 'bjxy-contact-wechat-img',
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer',
      key: 'wc-' + i
    }, m('img', {
      src: url,
      alt: '微信二维码 #' + (i + 1)
    }))))]) : null].filter(Boolean))]);
  }
  oncreate(vnode) {
    // v0.1.22: /bjxy 路径 HTML <title> 改为品牌名 + 品牌副标
    //   vendor Page setTitle 默认 setTitle(trans('core.forum.index.meta_title_text')) = '极客雪域'
    //   override 后变成 '北极雪屿 · 室内滑雪 · 全国连锁' (跟后台 '品牌信息' tab 设置联动)
    this.setTitle();
    this.loadCoaches();
    // v0.2.0i.n 删 (辉哥 2026-08-13 12:00 反馈): 移除 oncreate 注入 inline style 代码
    //   之前 v0.1.17 时代实现 (怕 mobile tab 扩展内部代码要改), v0.1.18/19/20/22 都在这个 inline style 上加规则
    //   v0.2.0i.l 才发现 #app-navigation 段误伤, v0.2.0i.m 才发现 mobile tab 隐藏切到 /u/wfl 残留 17.8px padding
    //   根除: 改成 less 段 + body class 控制 (oninit add bjxy-page-active, onremove remove), 走 SOP 234 page-level 套路
    //   老 fallback 节点 <style id="bjxy-hide-mobile-tab"> 在 onremove 段兜底移除 (兼容老 user 老 cache)
    //   if (app.forum.attribute('bjxy_show_mobile_tab') === '1') { ... } 段整段删除
    //   配套 less 段: body.bjxy-page-active { nav.MobileTab hide; #header hide; #app padding-top 63.8; .App.affix pb 0; .App-content pb 0; }
    //   v0.2.0i.aa.a 改 (辉哥 2026-08-31 16:21 反馈): 上面的 #header hide + #app padding-top 63.8 2 段已删, 现在 5 段 (见 oninit 注释)
  }
  loadCoaches() {
    // v0.1.4 改: 优先用 /api/bjxy/coaches (读 bjxy_coach_user_ids setting, 拿具体 user)
    //   fallback 老的 /api/bjxy/coaches (读 bjxy_coach_group_ids setting, 拿 group 内 user)
    //   两个 API 共存兼容旧部署
    m.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/bjxy/coaches'
    }).then(data => {
      this.coaches = data.coaches || [];
      this.loadingCoaches = false;
      m.redraw();
    }).catch(err => {
      console.error('bjxy load coaches failed', err);
      this.loadingCoaches = false;
      m.redraw();
    });
  }
}
flarum.reg.add('ziiven-bjxy-website', 'forum/components/BjxyPage', BjxyPage);